<template>
<!--  3:19-->
  <div>
    <cancel-heading>Forefront 101: On Demand</cancel-heading>
    <cancel-content>Getting leads can be tough. We've mapped a walkthrough of everything you need
      to know about Forefront to get started! So what are you waiting for, turn more leads into deals
      today!</cancel-content>
    <button-default @click="acceptWalkThruOffer">Watch Now</button-default>
  </div>
</template>

<script>
import CancelHeading from "./components/CancelHeading.vue";
import CancelContent from "./components/CancelContent.vue";

/**
 * NOTE: This is on hold because Kevin doesn't think it's a good idea
 */
export default {
  name: "OfferWalkThruVideo",
  components: {CancelContent, CancelHeading},
  methods: {
    acceptWalkThruOffer() {
      this.$emit('accepted')
    }
  },
}
</script>
